import { useMemo } from 'react';

export const usePortal = () => {
  const portalActive = useMemo(() => {
    return document.cookie.includes('sb-auth-token=');
  }, []);

  return {
    portalActive,
    handlePortalExit: () => {
      window.location.href = '/portal/exit';
    },
  };
};
